<mat-dialog-actions class="family-dialog-header">
    <span class="family-dialog-title">
        {{ prevData ? 'Editar familiar' : 'Datos del familiar' }}
    </span>
    <button class="family-dialog-close" mat-icon-button mat-dialog-close type="button" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>
</mat-dialog-actions>
<mat-dialog-content class="content-family">
    <div class="family-dialog-content">
        <p class="family-dialog-subtitle">
            {{
            prevData
            ? 'Actualiza los datos de tu familiar o amigo.'
            : 'Ingresa los datos de tu familiar o amigo.'
            }}
        </p>
        <form class="family-form" method="post" [formGroup]="familyForm" (ngSubmit)="saveFamily()">
            <!-- =====================================================
                 NOMBRE
                 ===================================================== -->
            <div class="family-field">
                <label for="family-name">
                    NOMBRE(S)
                </label>
                <mat-form-field class="family-input" appearance="outline">
                    <input id="family-name" matInput formControlName="name" type="text" placeholder="Nombre(s)">
                </mat-form-field>
                <mat-error *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="family-error">
                    {{ getErrorMessage('name') }}
                </mat-error>
            </div>
            <!-- =====================================================
                 APELLIDO PATERNO
                 ===================================================== -->
            <div class="family-field">
                <label for="family-last-name">
                    APELLIDO PATERNO
                </label>
                <mat-form-field class="family-input" appearance="outline">
                    <input id="family-last-name" matInput formControlName="last_name" type="text"
                        placeholder="Apellido paterno">
                </mat-form-field>
            </div>
            <!-- =====================================================
                 APELLIDO MATERNO
                 ===================================================== -->
            <div class="family-field">
                <label for="family-last-name2">
                    APELLIDO MATERNO
                </label>
                <mat-form-field class="family-input" appearance="outline">
                    <input id="family-last-name2" matInput formControlName="last_name2" type="text"
                        placeholder="Apellido materno">
                </mat-form-field>
            </div>
            <!-- =====================================================
                 PARENTESCO
                 ===================================================== -->
            <div class="family-field">
                <label for="family-position">
                    PARENTESCO
                </label>
                <mat-form-field class="family-input" appearance="outline">
                    <mat-select id="family-position" formControlName="familiar_position_id">
                        <mat-option value="">
                            Selecciona un parentesco
                        </mat-option>
                        <mat-option *ngFor="let pos of familiarPositions" [value]="pos.id">
                            {{ pos.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="
                        familyForm.get('familiar_position_id')?.invalid &&
                        (
                            familyForm.get('familiar_position_id')?.dirty ||
                            familyForm.get('familiar_position_id')?.touched
                        )
                    " class="family-error">
                    {{ getErrorMessage('familiar_position_id') }}
                </mat-error>
            </div>
            <!-- =====================================================
                 FECHA DE NACIMIENTO
                 ===================================================== -->
            <div class="family-field">
                <label for="family-birthdate">
                    FECHA DE NACIMIENTO
                </label>
                <mat-form-field class="family-input" appearance="outline">
                    <input id="family-birthdate" matInput [matDatepicker]="birthdatePicker" formControlName="birthdate" placeholder="dd/mm/aaaa" readonly="true">
                    <button type="button" mat-icon-button class="family-datepicker-button" (click)="birthdatePicker.open()" aria-label="Abrir calendario">
                        <mat-icon>calendar_today</mat-icon>
                    </button>
                    <mat-datepicker #birthdatePicker></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="familyForm.get('birthdate')?.invalid && (familyForm.get('birthdate')?.dirty || familyForm.get('birthdate')?.touched)" class="family-error">
                    {{ getErrorMessage('birthdate') }}
                </mat-error>
            </div>
            <!-- =====================================================
                 GUARDAR
                 ===================================================== -->
            <button class="family-submit" mat-raised-button type="submit" [disabled]="!familyForm.valid">
                {{ prevData ? 'Guardar cambios' : 'Agregar familiar' }}
            </button>
        </form>
    </div>
</mat-dialog-content>